import { ListSortDirection, Sort } from "../../models/api/sort";
import { DocumentRequestDTO } from "../../models/employee-document-requests/document-request-dto";
import { DocumentRequestSTO } from "../../models/employee-document-requests/document-request-sto";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base/base-api.service";

export class EmployeesDocRequestsApiService extends BaseApiService<DocumentRequestDTO, DocumentRequestSTO> {
  constructor() {
    super({
      servicePath: "/EmployeesDocRequests",
      loadItemsPath: "/GetEmployeesDocRequests",
      saveItemsPath: "/SaveEmployeesDocRequests",
    });
    this.defaultSort = [
      {
        name: "employee.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "requestType.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "requestType.documentType.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const saveEmployeeDocRequest = async (employeeDocRequest: DocumentRequestSTO) => {
  const res = await new EmployeesDocRequestsApiService().saveItems([employeeDocRequest]);

  toastifyResponse(res);

  return res;
};
